import React from "react";
import { useTranslation } from 'react-i18next';
import Header from "../Header";
import Footer from "../Footer";
// import { pages } from '../../utils/data'
import trekzyLogo from '../../assets/images/trekzy-logo.svg'
import toursprivados from '../../assets/images/toursprivadosbytrekzy-logo.png'

const MainLayout = ({ children }) => {
    const { t } = useTranslation('paths');
    const { i18n } = useTranslation();
    const pages = [
        {
            text: t('destinations-title'),
            url: `/${t('destinations')}`
        },
        {
            text: t('guides-title'),
            url: `/${t('guides')}`
        }
    ]

    return (
        <>
            <Header logoImgSource={i18n.language == 'es' ? toursprivados : trekzyLogo} logoWidth={i18n.language == 'es' ? '15rem' : '8rem'} pages={pages} />
            {children}
            <Footer />
        </>
    )
}

export default MainLayout;